// イベントの二重登録を防ぐ。data-{key}Bound を立て、初回だけ true を返す。
// 使い方: if (!bindOnce(node, 'smoothScroll')) return;
export function bindOnce(el, key) {
  const flag = `${key}Bound`;
  if (el.dataset[flag] === '1') return false;
  el.dataset[flag] = '1';
  return true;
}
